<template>
	<footer class="footer">
		<!-- <section class="newsletter">
			<div class="container">
				<div class="row justify-content-center">
					<div class="col-sm-10 col-md-8 col-lg-6">
						<div class="cta-heading text-center">
							<h3 class="cta-title text-white">Get The Latest Deals</h3>
							<p class="cta-desc">and receive <span class="font-weight-normal">R50 coupon</span> for first shopping</p>
						</div>

						<form action="#">
							<div class="input-group input-group-round">
								<input
									type="email"
									class="form-control form-control-white"
									placeholder="Enter your Email Address"
									aria-label="Email Adress"
									required=""
								>
								<div class="input-group-append">
									<button
										class="btn"
										type="submit"
									>Subscribe</button>
								</div>
							</div>
						</form>
					</div>
				</div>
			</div>
		</section> -->
		<div class="footer-middle">
			<div class="container">
				<div class="row">
					<div class="col-sm-3 col-lg-3">
						<div class="widget widget-about">
							<h3 class="widget-title">About Airabica</h3>
							<p>Airabica roasters provide speciality coffee and services to satisfy your needs. </p>

							<div class="social-icons">
								<a
									:href="fbUrl"
									class="social-icon"
									title="Facebook"
									target="_blank"
								><i class="icon-facebook-f"></i></a>
								<!-- <a
									href="#"
									class="social-icon"
									title="Twitter"
									target="_blank"
								><i class="icon-twitter"></i></a> -->
								<a
									:href="instagramUrl"
									class="social-icon"
									title="Instagram"
									target="_blank"
								><i class="icon-instagram"></i></a>
								<a
									:href="youtubeUrl"
									class="social-icon"
									title="Youtube"
									target="_blank"
								><i class="icon-youtube"></i></a>
							</div>
						</div>
					</div>

					<div class="col-sm-3 col-lg-3">
						<div class="widget">
							<h3 class="widget-title">Useful Links</h3>

							<ul class="widget-list">
								<li>
									<nuxt-link to="/">Home</nuxt-link>
								</li>
								<li>
									<nuxt-link to="/shop/nosidebar/boxed">Shop</nuxt-link>
								</li>
								<li>
									<nuxt-link to="/wholesale/order">Order</nuxt-link>
								</li>
								<li>
									<nuxt-link to="/about-us">About Airabica</nuxt-link>
								</li>
								<!-- <li><a href="#">How to shop on Molla</a></li> -->
								<!-- <li><a href="#">FAQ</a></li> -->
								<li>
									<nuxt-link to="/contact-us">Contact us</nuxt-link>
								</li>
								
								<!-- <li>
									<nuxt-link to="/pages/login">Log in</nuxt-link>
								</li> -->
							</ul>
						</div>
					</div>

					<div class="col-sm-6 col-lg-6">
						<div class="widget">
							<h4 class="widget-title">Supplier of coffee equipment</h4>

							<ul class="widget-list">
								<li>
									AeroPress, Airmotion, Anfim, Brewtool, BWT, Bialetti, BruTrek, CINOART, Coffee Queen, CREM, Ditting,
									Everpure/Pentair, Espazolla, Eureka, Eversys, Hario, Henlo, La Cimbali, la marzocco, Idroprep, Lizzard, Mahlkönig, 
									PuQ Press, Red Espresso, Saeco, Simonelli, Timemore, Victoria Arduino, Wacaco, 1Zpresso
									<!-- <p>We supply various coffe equipment</p> -->
									<!--a
										href="https://scasa.coffee/"
										title="SCASA"
										target="_blank"
									>	
										<img
											v-lazy="'/images/icons/scasa-logo.webp'"
											class="bg-transparent"
											width="300"											
											alt="SCASA logo"
										/>
									</a>	 -->
								</li>
							</ul>
						</div>
					</div>

					<!-- <div class="col-sm-6 col-lg-3">
						<div class="widget">
							<h4 class="widget-title">Customer Service</h4>

							<ul class="widget-list">
								<li><a href="#">Payment Methods</a></li>
								<li><a href="#">Money-back guarantee!</a></li>
								<li><a href="#">Returns</a></li>
								<li><a href="#">Shipping</a></li>
								<li><a href="#">Terms and conditions</a></li>
								<li><a href="#">Privacy Policy</a></li>
							</ul>
						</div>
					</div> -->

					<!-- <div class="col-sm-6 col-lg-3">
						<div class="widget">
							<h4 class="widget-title">My Account</h4>

							<ul class="widget-list">
								<li>
									<nuxt-link to="/pages/login">Sign In</nuxt-link>
								</li>
								<li>
									<nuxt-link to="/shop/cart">View Cart</nuxt-link>
								</li>
								<li>
									<nuxt-link to="/shop/wishlist">My Wishlist</nuxt-link>
								</li>
								<li><a href="#">Track My Order</a></li>
								<li><a href="#">Help</a></li>
							</ul>
						</div>
					</div> -->
				</div>
			</div>
		</div>

		<div class="footer-bottom">
			<div class="container">
				<!-- <figure class="footer-payments">
					<img
						src="~/public/images/payments.png"
						alt="Payment methods"
						class="bg-transparent"
						width="272"
						height="20"
					/>
				</figure> -->
				<img
					src="/images/home/logo.png"
					class="bg-transparent"
					alt="Footer Logo"
					width="82"
					height="20"
				/>
				<p class="footer-copyright">Copyright © {{ new Date().getFullYear() }} Airabica. All Rights Reserved.</p>
			</div>
		</div>
		<div
			class="mb-10"
			v-if="bottomSticky"
		></div>
	</footer>
</template>

<script>

import { fb_url,instagram_url,youTubeChannel_url } from '~/utilities/data';
export default {
	data: function() {
		return {
			bottomSticky: false,
			fbUrl: fb_url,
			instagramUrl: instagram_url,
			youtubeUrl: youTubeChannel_url
		};
	},
	computed: {
		isFullwidth: function() {
			return this.$route.path.includes('fullwidth');
		}
	},
	watch: {
		$route: function() {
			this.handleBottomSticky();
		}
	},
	mounted: function() {
		this.handleBottomSticky();
		window.addEventListener('resize', this.handleBottomSticky, {
			passive: true
		});
	},
	destroyed: function() {
		window.removeEventListener('resize', this.handleBottomSticky);
	},
	methods: {
		handleBottomSticky: function() {
			this.bottomSticky =
				this.$route.path.includes('/product/default') &&
				window.innerWidth > 991;
		}
	}
};
</script>